import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { useTenants } from '@/services/tenants/useTenants';
import { TileEmptyStateAction } from './TileEmptyState';

export const useUploadAssetsAction = (): TileEmptyStateAction | undefined => {
  const { getPath } = useTenants();
  const { permissions } = useGetCurrentUser();

  return permissions.canUploadAssets ? { label: 'Upload assets', to: getPath('assets') } : undefined;
};
